<template>
  <div class="public-upload">
    <userHeader />
    <slot />
    <userFooter />
  </div>
</template>

<script>
  import 'toastr/build/toastr.min.css'

  import Header from '../views/public/Header'
  import Footer from '../views/public/Footer'

  export default {
    components: {
      userHeader: Header,
      userFooter: Footer
    },
    name: 'public'
  }
</script>
<style lang="sass" scoped>
  .public-upload
    display: flex
    flex-direction: column
    min-height: 100vh
    .upload-file-wrapper
      flex: 1
</style>
